const styles = (theme) => ({
    root: {
        width: '49.5%',
    },
    root1: {
        width: '49.5%'
    },
    card1: {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        height: '100%',
    },
    balance: {
        display: 'flex',
        flexWrap: 'wrap'
    },
    balanceActions: {
        display: 'flex',
        alignItems: 'flex-end'
    },
    download: {
        backgroundColor: '#409443',
        '&:hover': {
            backgroundColor: '#409443',
        }
    },
    paymentsummary: {
        display: 'flex',
        justifyContent: 'space-between',
        width: '50%'
    }
});

export default styles;
